import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { AboutSection } from '../components/AboutSection';
import { PhasesSection } from '../components/PhasesSection';
import { AgendaSection } from '../components/AgendaSection';
import { RouteMapSection } from '../components/RouteMapSection';
import { VenueMapSection } from '../components/VenueMapSection';
import { PetWallSection } from '../components/PetWallSection';
import { TicketsSection } from '../components/TicketsSection';
import { SponsorsSection } from '../components/SponsorsSection';
import { ActivitiesSection } from '../components/ActivitiesSection';
import { LocationSection } from '../components/LocationSection';
import { CauseSection } from '../components/CauseSection';
import { ContactSection } from '../components/ContactSection';
import { SponsorsBannerSection } from '../components/SponsorsBannerSection';
export function HomePage() {
  return <>
      <HeroSection data-id="element-2176" />
      <ActivitiesSection data-id="element-2177" />
      <AboutSection data-id="element-2178" />
      <TicketsSection data-id="element-2179" />
      <CauseSection data-id="element-2180" />
      <SponsorsBannerSection data-id="element-2181" />
      <SponsorsSection data-id="element-2182" />
      <AgendaSection data-id="element-2183" />
      <RouteMapSection data-id="element-2184" />
      <VenueMapSection data-id="element-2185" />
      <PetWallSection data-id="element-2186" />
      <LocationSection data-id="element-2187" />
      <PhasesSection data-id="element-2188" />
      <ContactSection data-id="element-2189" />
    </>;
}